/**
 * Created by imranexpt on 11/05/2021.
 */
(function() {
    /** @ngInject */
    function editBookingCtrl($scope, $http){
        $scope.amounts   = [];//$scope.booking.getAmountsList();
        $scope.update_vars = {amount : false, time : false};
        $scope.update_vals = {amount : $scope.booking.amount, time : $scope.booking.time};
        $scope.editBookingStep = function(step){
            if(_.isUndefined(step))
                $scope.booking._edit.status = !$scope.booking._edit.status;
            else
                $scope.booking._edit.step = step;
            if(step == 'amount')
                initGuestsList();
            if(step === 'time'){
                initTimeList();
            }
        };
        $scope.editBooking = function(){
            return $scope.booking._edit.status;
        };
        function loadAjax(){
            var ajaxElem = document.querySelector('#ajaxloader');
            ajaxElem.classList.add('ajaxInline');
        }
        function hideAjax(){
            var ajaxElem = document.querySelector('#ajaxloader');
            ajaxElem.classList.remove('ajaxInline');
        }
        var waitlist = '';
        $scope.selectAmount = function(amount){
            if(amount.status && amount.status === 1) {
                $scope.update_vals['amount'] = amount.num;
                $scope.update_vars.amount = true;
                $scope.booking._edit.step = 'confirm';
            }
            //initTimeList();
        };
        $scope.setTime = function(time){
            $scope.update_vars.time = true;
            $scope.update_vals['time'] = time;
            $scope.booking._edit.step = 'confirm';
        };
        $scope.closePanel = function(){
            $scope.booking._edit = {status : false, step : ''};
            $scope.update_vals = {amount : $scope.booking.amount, time : $scope.booking.time};
            $scope.update_vars = {amount : false, time : false};
        }
        /** Timelist related **/
        $scope.timelist = [];
        $scope.booking.last_timelist = [];
        $scope.checkWaitlist = false;
        $scope.booking.last_timelist_full = [];
        //$scope.booking.waitlist = false;
        $scope.canSeeAlternateRests = false;
        $scope.canSeeNext30Days = false;

        $scope.getTimeLabel = function(time){
            var label = $scope.full_text_labels['type_2'];
            if(_.has($scope.too_late, time)){
                return $scope.full_text_labels['type_3'];
            }
            if(_.has($scope.stop_time, time)){
                return $scope.stopTimeLabel();
            }
            return label;
        };
        $scope.printLabel = function(lbl){
            return lbl === 'No Category' ? no_cat_label : lbl;
        };
        function resetList(){
            $scope.booking.last_timelist = [];
            $scope.checkWaitlist = false;
            $scope.booking.last_timelist_full = [];
            //$scope.booking.waitlist = false;
            $scope.canSeeAlternateRests = false;
            $scope.canSeeNext30Days = false;
        }
        $scope.getTimelist = function(){
            return _.filter($scope.booking.last_timelist_full, function(t){
                return $scope.isVisibleTime(t[0]);
            });
        };
        $scope.isVisibleTime = function(time){
            if($scope.isAvailableTime(time)) return true;
            if(waitlist !== 'Y') return false;
            return !isToday || _.parseInt(time_now) <= _.parseInt(time.replace(':',''));
        };
        $scope.isAvailableTime = function(time){
            return _.find($scope.booking.last_timelist, function(t){
                return t[0] === time;
            });
        };
        $scope.hasAvailableTime = function(){
            return _.size($scope.booking.last_timelist) > 0;
        };

        $scope.saveChanges = function(){
            var tRequest = {
                testmode: 0,
                amount: $scope.update_vals.amount,
                mealid: $scope.booking.mealid,
                short_code : $scope.booking.short_code,
                time : $scope.update_vals.time,
                hash: hash,
                int_test : 1
            };
            loadAjax();
            $http.post("/reservation/api/booking/updateBooking", tRequest).success(function (response) {
                hideAjax();
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    $scope.closePanel();
                    //alert("Successfully updated booking");
                    window.location = window.location.href + '&is_updated=yes';
                    /*
                    var sElem = document.querySelector('#booking-success');
                    if(sElem){
                        sElem.innerHTML = '<p><strong>' + response.successTitle + '</strong></p><p>' + response.successDesc + '</p>';
                    }

                    if($scope.update_vals.amount)
                        $scope.booking.amount = $scope.update_vals.amount;
                    if($scope.update_vals.time)
                        $scope.booking.time = $scope.update_vals.time;*/
                }
            });
        }

        function initGuestsList(){
            var trequest = {
                testmode: 0,
                date: $scope.booking.getDate("YYYY-MM-DD"),
                mealid: $scope.booking.mealid,
                short_code : $scope.booking.short_code,
                hash: hash,
                int_test : 1,
                time : $scope.booking.time,
            };
            loadAjax();
            $http.post('/booking-widget/api/getGuestsAvailibility', trequest).success(function(response){
                hideAjax();
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    if(_.has(response, 'guests')){
                        $scope.amounts = response.guests;
                    }
                }
            });
        }


        function initTimeList(){
            resetList();
            $scope.labels = {};
            var trequest = {
                testmode: 0,
                date: $scope.booking.getDate("YYYY-MM-DD"),
                amount: $scope.update_vals.amount,
                mealid: $scope.booking.mealid,
                short_code : $scope.booking.short_code,
                hash: hash,
                int_test : 1
            };
            if($scope.booking.seating_length && _.parseInt($scope.booking.seating_length) > 0){
                trequest['length'] = $scope.booking.seating_length;
            }
            $scope.booking.waitlist_full = [];
            loadAjax();
            $http.post("/booking-widget/api/getTimes", trequest).success(function (response) {
                hideAjax();
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    if (_.has(response, 'ap_labels'))
                        $scope.labels = response.ap_labels;
                    $scope.booking.last_timelist = response.times;
                    $scope.booking.last_timelist_full = response.full;
                    $scope.full_text = response.full_text;
                    $scope.too_late   = response.too_late;
                    $scope.stop_time   = response.stop_time;
                    $scope.full_text_labels = response.full_text_labels;
                }
            });
        }

    }
    angular.module("Waiteraid").controller("editBookingCtrl", editBookingCtrl);
})();
